<template>
  <div>
    <main-layout>
      <AdminMenu />
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12>
            <h5>Patient</h5>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em class="fas fa-angle-down" v-if="!showAdvancedSearch" />
              <em class="fas fa-angle-up" v-else />
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-sm-right text-xs-right">
            <v-btn dark outline color="primary" @click="handleExportXlsx" :loading="loading">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs3 px-2>
                  <div class="caption">ชื่อจริง</div>
                  <input type="text" v-model="filter.first_name" placeholder="ชื่อจริง" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">นามสกุล</div>
                  <input type="text" v-model="filter.last_name" placeholder="นามสกุล" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">อายุ</div>
                  <input type="text" v-model="filter.age" placeholder="อายุ" />
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">เพศ</div>
                  <multiselect
                    v-model="filter.gender"
                    :options="genderOptions"
                    label="label"
                    selectLabel
                    selectedLabel
                    track-by="value"
                  ></multiselect>
                </v-flex>

                <v-flex xs3 px-2>
                  <div class="caption">วันที่เริ่มต้น</div>
                  <DatepickerCustomDialog v-model="filter.date_from" :allowed-dates="allowedDates">
                    <input
                      type="text"
                      :value="handleGetDateFormatted(filter.date_from)"
                      placeholder="เลือกวันที่เริ่มต้น"
                      readonly
                    />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">วันที่สิ้นสุด</div>
                  <DatepickerCustomDialog v-model="filter.date_to" :allowed-dates="allowedDates">
                    <input
                      type="text"
                      :value="handleGetDateFormatted(filter.date_to)"
                      placeholder="เลือกวันที่สิ้นสุด"
                      readonly
                    />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs3 px-2>
                  <div class="caption">สถานะ</div>
                  <multiselect
                    v-model="filter.status"
                    :options="statusOptions"
                    selectLabel
                    selectedLabel
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed @click="handleSearch" color="primary">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="patientListData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template slot="headerCell" slot-scope="props">
            <HeaderTableWithSort
              :headers="props.header"
              :sortBy.sync="sortBy"
              :orderBy.sync="orderBy"
              @onSort="handleChangeSort"
            ></HeaderTableWithSort>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.first_name || '-' }}</td>
              <td>{{ props.item.last_name || '-' }}</td>
              <td>{{ props.item.age || '-' }}</td>
              <td>{{ handleGetGenderLabel(props.item.gender) || '-' }}</td>
              <td>{{ props.item.weight || '-' }}</td>
              <td><span v-html="handleGetStatusColor(props.item.status)"></span></td>
              <td>{{ handleGetDateWithTime(props.item.timestamp) || '-' }}</td>
              <td>
                <v-btn dark small color="primary" @click="handleShowDetails(props.item.id)">
                  {{ $t('view') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'
import { DATETIME } from '@/constants/datetime.js'
import Multiselect from 'vue-multiselect'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import AdminMenu from './AdminMenu.vue'

export default {
  components: {
    AdminMenu,
    HeaderTableWithSort,
    Multiselect,
    DatepickerCustomDialog
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      patientListData: [],
      headers: [
        { text: 'ลำดับที่', value: 'id', customSort: true, sortable: false },
        { text: 'ชื่อจริง', value: 'first_name', customSort: true, sortable: false },
        { text: 'นามสกุล', value: 'last_name', customSort: false, sortable: false },
        { text: 'อายุ', value: 'age', customSort: true, sortable: false },
        { text: 'เพศ', value: 'gender', customSort: true, sortable: false },
        { text: 'น้ำหนัก', value: 'weight', customSort: false, sortable: false },
        { text: 'สถานะ', value: 'status', customSort: true, sortable: false },
        { text: 'วันที่เริ่มทำประเมิน', value: 'timestamp', customSort: true, sortable: false },
        { text: '', value: '', customSort: false, sortable: false }
      ],
      sortBy: 'id',
      orderBy: ORDER_BY.DESC,
      showAdvancedSearch: false,
      statusOptions: ['ความเสี่ยงต่ำ', 'ความเสี่ยงปานกลาง', 'ความเสี่ยงสูง'],
      genderOptions: [
        {
          label: 'ชาย',
          value: 'male'
        },
        {
          label: 'หญิง',
          value: 'female'
        }
      ],
      filter: {
        first_name: '',
        last_name: '',
        age: '',
        gender: '',
        status: '',
        date_from: '',
        date_to: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetPatientList()
  },
  methods: {
    async handleGetPatientList() {
      const vm = this
      try {
        const response = await vm.getPatientList()
        if (response) {
          vm.patientListData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPatientList() {
      const vm = this
      const limit = vm.isExport ? vm.total : vm.limit
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: limit,
        offset: vm.offset,
        sort_by: vm.sortBy,
        order_by: vm.orderBy
      }

      Object.entries(vm.filter).forEach(([key, value]) => {
        if (value && Object.keys(value).length > 0) {
          Object.assign(data, { [key]: value.value })
        }
        if (value && value.length) {
          Object.assign(data, { [key]: value.toLowerCase() })
        }
      })

      vm.loading = true
      const response = await nongtungjaiApi.getPatientList({
        config: {
          params: data
        }
      })

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const data = await vm.getPatientList()
      const requestData = data.data
      vm.isExport = false

      if (requestData == null) return
      const requests = requestData.map((el) => {
        return {
          id: el.id,
          first_name: el.first_name,
          last_name: el.last_name,
          age: el.age,
          gender: vm.handleGetGenderLabel(el.gender),
          weight: el.weight,
          status: el.status ? el.status : '-',
          timestamp: vm.handleGetDateFormatted(el.timestamp)
        }
      })

      const heading = [
        [
          'ลำดับที่',
          'ชื่อจริง',
          'นามสกุล',
          'อายุ',
          'เพศ',
          'น้ำหนัก',
          'สถานะ',
          'วันที่เริ่มทำประเมิน'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `patient-history.xlsx`)
    },
    handleShowDetails(id) {
      this.$router.push(`patient-history/${id}`)
    },
    handleGetDateWithTime(value) {
      try {
        const date = new Date(value)
        return moment(date).format(DATETIME.DATETIME_FORMAT_DISPLAY)
      } catch (error) {
        return ''
      }
    },
    handleGetDateFormatted(value) {
      return value ? moment(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    handleGetGenderLabel(value) {
      return value === 'male' ? 'ชาย' : 'หญิง'
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'ความเสี่ยงต่ำ':
            color = 'success'
            break
          case 'ความเสี่ยงปานกลาง':
            color = 'yellow'
            break
          case 'ความเสี่ยงสูง':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        return `<span class="${color}--text">${status}</span>`
      } else {
        return '-'
      }
    },

    handleSearch() {
      this.reset()
      this.handleCloseSearch()
    },
    handleClearSearch() {
      this.filter = {
        first_name: '',
        last_name: '',
        age: '',
        gender: '',
        status: '',
        date_from: '',
        date_to: ''
      }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetPatientList()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetPatientList()
    },
    handleChangeSort() {
      this.reset()
    },
    allowedDates(val) {
      return moment().diff(val, 'days') > 0
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/PatientHistory.vue